import * as React from "react";
import { forwardRef } from "react";
const SvgArrowDownIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 14, height: 8, viewBox: "0 0 14 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0.0101566 1.41L1.42016 -5.241e-07L6.71016 5.29L12.0002 -6.16331e-08L13.4102 1.41L7.41016 7.41C7.02016 7.8 6.39016 7.8 6.00016 7.41L0.000156341 1.41L0.0101566 1.41Z", fill: "#3867D6" }));
const ForwardRef = forwardRef(SvgArrowDownIcon);
export default ForwardRef;
